import React from 'react';
import Theme from '../../theme';
import { Text, View } from 'react-native';
import { defaultScale } from '../../utils/scaling';

export const WorkoutFormat = ({ t, formatType }) => {
  const workoutFormatTextMap = {
    6: t('workoutFormat_6'),
    11: t('workoutFormat_11'),
    16: t('workoutFormat_16'),
  };

  return (
    <View>
      <Text style={[Theme.textStyle.heading2, {marginBottom: defaultScale(18)}]}>Workout format</Text>
      <Text style={Theme.textStyle.bodyCopyReg}>
        {workoutFormatTextMap[formatType]}
      </Text>
    </View>
  );
};
